import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import slCommon from '@/locales/sl/common.json';
import slOnboarding from '@/locales/sl/onboarding.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      sl: {
        common: slCommon,
        onboarding: slOnboarding,
      },
    },
    lng: 'sl',
    fallbackLng: 'sl',
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
